
import React from 'react';
import { formatCurrency } from '../../utils/calculator';
import { InfoTooltip } from '../../ui/InfoTooltip';

interface IncomeBreakdownProps {
  formData: any;
  results: any;
}

export function IncomeBreakdown({ formData, results }: IncomeBreakdownProps) {
  return (
    <div className="bg-white rounded-lg border overflow-hidden">
      <div className="bg-grandpal-green/10 p-4 border-b">
        <h4 className="font-semibold text-grandpal-green">Income Contribution</h4>
      </div>
      <div className="p-5 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-grandpal-gray mb-1">Gross Income</p>
            <p className="font-medium">{formatCurrency(formData.grossIncome)}/year</p>
          </div>
          <div>
            <p className="text-sm text-grandpal-gray mb-1">Total Deductions</p>
            <p className="font-medium">{formatCurrency(
              formData.incomeTax + 
              formData.usc + 
              formData.prsi + 
              formData.propertyTax + 
              formData.homeLoanInterest + 
              formData.maintenancePayments + 
              formData.healthExpenses
            )}/year</p>
          </div>
        </div>
        
        <div className="border-t pt-4 flex justify-between items-center">
          <div className="flex items-center gap-1">
            <p className="font-medium">Assessable Income</p>
            <InfoTooltip content="Your income after all allowable deductions." />
          </div>
          <p className="font-medium">{formatCurrency(
            formData.grossIncome - (
              formData.incomeTax + 
              formData.usc + 
              formData.prsi + 
              formData.propertyTax + 
              formData.homeLoanInterest + 
              formData.maintenancePayments + 
              formData.healthExpenses
            )
          )}/year</p>
        </div>
        
        <div className="border-t pt-4 flex justify-between items-center">
          <div className="flex items-center gap-1">
            <p className="font-medium">
              {formData.applicantStatus === 'single' 
                ? "80% of Assessable Income" 
                : "40% of Combined Income"}
            </p>
            <InfoTooltip content={
              formData.applicantStatus === 'single'
                ? "Under Fair Deal, you contribute 80% of your assessable income."
                : "As a couple, you contribute 40% of combined income (equivalent to 80% of half)."
            } />
          </div>
          <p className="font-semibold text-grandpal-green">{formatCurrency(results.incomeContribution.annual)}/year</p>
        </div>
        
        <div className="border-t pt-4 flex justify-between items-center">
          <div className="flex items-center gap-1">
            <p className="font-medium">Weekly Income Contribution</p>
          </div>
          <p className="font-semibold text-grandpal-green">{formatCurrency(results.incomeContribution.weekly)}/week</p>
        </div>
      </div>
    </div>
  );
}
